module.exports = __webpack_public_path__ + "static/img/face11.5839877.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face11.jpg
// module id = D2Tv
// module chunks = 0